import { IApplicationState, TBoardId } from '../../../../../types/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';

export const getMyWorkUnselectedBoards = (
    state: IApplicationState
): TBoardId[] => {
    return getAuthUserMetaMyWork(state).unselectedBoards || [];
};
